import { render, staticRenderFns } from "./DeptDetail.vue?vue&type=template&id=51941c78&scoped=true"
import script from "./DeptDetail.vue?vue&type=script&lang=js"
export * from "./DeptDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51941c78",
  null
  
)

export default component.exports